import { Button, Typography } from "@mui/material";
import { useStore } from "../../../../store/store";
import axios from "axios";
import { useState } from "react";
import { Session } from "../../../../types/records.types";
import { SimpleUser } from "../../../../types/user.types";
import { prepareMeetingData } from "../../utils";
import { ConfirmMeetingDialog } from "./ConfirmMeetingDialog";
import { MAKE_WEBHOOKS } from "../../../../utils/constants";

export interface ExtendedSessionType extends Session {
    treatment: Session["treatment"] & {
        client: {
            user_id: SimpleUser;
        };
    };
}

type SendMeetingButtonProps = {
    session: ExtendedSessionType;
    updateMeetingCache: ({meeting_id, meeting_url}:{meeting_id:string, meeting_url: string}) => void
    meetingName: string
};

export const SendMeetingButton = ({ session, updateMeetingCache, meetingName}: SendMeetingButtonProps) => {
    const { notifications } = useStore();

    const [additionalEmails, setAdditionalEmails] = useState<Array<string>>([]);

    const [openDialog, setOpenDialog] = useState(false);
    const toggleOpenDialog = async () => {
        setOpenDialog((prev) => !prev);
    };
    
    const preparedSessionData = prepareMeetingData(session, additionalEmails);
    const [title, setTitle] = useState(preparedSessionData.session.title);
    const [isWatingForReponse, setIsWatingForReponse] = useState(false);

    const handleSendMeetingToClient = async (sessionData: typeof preparedSessionData) => {
        setIsWatingForReponse(true)
        const formattedEmails = sessionData.emailsToSend.map((email) => {
            return { email: email };
        });

        const data = {
            id:sessionData.session.id,
            emailsToSend: formattedEmails,
            title: title,
            isDelete: false
        };
        
        try {
            const response = await axios.post(
            MAKE_WEBHOOKS.google_meet,
            data
            );
            
            notifications.setNotification({
                isOpen: true,
                message: "Convite enviado com sucesso",
                severity: "success",
            });
            updateMeetingCache(response.data);
        } catch (error) {
            const errorMessage =
                axios.isAxiosError(error) && error.response?.data
                    ? error.response.data
                    : "Erro ao enviar convite";
            notifications.setNotification({ isOpen: true, message: errorMessage, severity: "error" });
        }
        toggleOpenDialog();
        setIsWatingForReponse(false)
    };

    
        return (
            <>
                <Button size="large" disableElevation onClick={toggleOpenDialog}>
                    <Typography variant="body1">Enviar convite para {meetingName}</Typography>
                </Button>
                <ConfirmMeetingDialog
                    open={openDialog}
                    toggleOpen={toggleOpenDialog}
                    data={preparedSessionData}
                    additionalEmails={additionalEmails}
                    setAdditionalEmails={setAdditionalEmails}
                    onSubmit={() => handleSendMeetingToClient(preparedSessionData)}
                    title={title}
                    setTitle={setTitle}
                    disableSubmitButton={isWatingForReponse}
                    meetingName={meetingName}
                />
            </>
        );
    }
